module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "landing-middle__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "landing-middle__layout-form"
  }, [_c('prb-stepper', {
    attrs: {
      "disable": !_vm.terms
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('prb-footer')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-513fc978"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrbLanding.vue
// module id = 559
// module chunks = 1